// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../platform/@jutro/cli-app/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__TypeOfRepairPage__repairChoices .jut__RadioButtonCardField__moneyAmount{display:none}", "",{"version":3,"sources":["webpack://./node_modules/gw-capability-fnol-pa-react/pages/TypeOfRepair/TypeOfRepairPage.module.scss"],"names":[],"mappings":"AACE,8EACE,YAAA","sourcesContent":[".repairChoices {\n  :global(.jut__RadioButtonCardField__moneyAmount) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"repairChoices": "app__TypeOfRepairPage__repairChoices"
};
export default ___CSS_LOADER_EXPORT___;
